import { Reveal } from "@/components/common/Reveal";
import { HeartHandshake, ScanLine, ShieldCheck } from "lucide-react";

const PILLARS = [
  { title: "Thoughtful Dentistry", description: "We listen first, examine carefully, and recommend only what truly serves your long-term health.", Icon: HeartHandshake },
  { title: "Digital Precision", description: "Digital scanning and planning bring accuracy, comfort, and predictable outcomes.", Icon: ScanLine },
  { title: "Long-term Oral Health", description: "Our goal is not a quick fix, but a stable, healthy smile that lasts for decades.", Icon: ShieldCheck },
];

export const PhilosophyPillars = ({ compact = false }) => (
  <div data-testid="philosophy-pillars" className={`grid grid-cols-1 md:grid-cols-3 gap-6 ${compact ? "" : "lg:gap-8"}`}>
    {PILLARS.map((p, i) => (
      <Reveal key={p.title} delay={i * 0.08}>
        <div className="h-full rounded-[var(--cdt-radius-md)] bg-white border border-[color:var(--cdt-border)] shadow-[var(--cdt-shadow-sm)] p-6">
          <div className="h-11 w-11 rounded-full bg-[rgba(15,92,90,0.08)] flex items-center justify-center">
            <p.Icon className="h-5 w-5 text-[var(--cdt-primary)]" />
          </div>
          <h3 className="font-display text-xl mt-4 text-[var(--cdt-text)]">{p.title}</h3>
          <p className="mt-2 text-sm leading-7 text-[var(--cdt-muted)]">{p.description}</p>
        </div>
      </Reveal>
    ))}
  </div>
);
